export default __webpack_public_path__ + "static/media/collectibles.29ab8659.png";